var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "deposit detail" },
    [
      _vm.lang == _vm.$config.LANG_KOR
        ? [
            _c("div", { staticClass: "scroll" }, [
              _c("article", { staticClass: "content-header bg-type" }, [
                _vm._m(0),
                _vm._m(1),
                true
                  ? _c("div", { staticClass: "summary" }, [
                      _vm._m(2),
                      _vm._m(3)
                    ])
                  : _vm._e()
              ]),
              _vm._m(4)
            ])
          ]
        : _vm.lang == _vm.$config.LANG_ENG
        ? [
            _c("div", { staticClass: "scroll" }, [
              _c("article", { staticClass: "content-header bg-type" }, [
                _vm._m(5),
                _vm._m(6),
                true
                  ? _c("div", { staticClass: "summary" }, [
                      _vm._m(7),
                      _vm._m(8)
                    ])
                  : _vm._e()
              ]),
              _vm._m(9)
            ])
          ]
        : [
            _c("div", { staticClass: "scroll" }, [
              _c("article", { staticClass: "content-header bg-type" }, [
                _vm._m(10),
                _vm._m(11),
                true
                  ? _c("div", { staticClass: "summary" }, [
                      _vm._m(12),
                      _vm._m(13)
                    ])
                  : _vm._e()
              ]),
              _vm._m(14)
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h2", [_vm._v("기업보통예금")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _c("p", [
        _vm._v(" 일시적 여유자금 보관목적의 입금 및 출금이 자유로운 예금 ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "tit" }, [
        _c("span", { staticClass: "exchange-unit" }, [_vm._v("USD")]),
        _c("span", { staticClass: "text" }, [_vm._v("연 ")])
      ]),
      _c("div", { staticClass: "percent" }, [_vm._v(" 0.50% ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "tit" }, [
        _c("span", { staticClass: "exchange-unit" }, [_vm._v("KHR")]),
        _c("span", { staticClass: "text" }, [_vm._v("연 ")])
      ]),
      _c("div", { staticClass: "percent" }, [_vm._v(" 0.70% ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { staticClass: "contents" }, [
      _c("dl", { staticClass: "dlist dlist-item--type5" }, [
        _c("dt", [_vm._v("상품유형")]),
        _c("dd", [_vm._v("보통예금")]),
        _c("dt", [_vm._v("상품개요")]),
        _c("dd", [
          _vm._v("일시적 여유자금 보관목적의 입금 및 출금이 자유로운 예금")
        ]),
        _c("dt", [_vm._v("가입대상")]),
        _c("dd", [_vm._v("캄보디아내 현지법인")]),
        _c("dt", [_vm._v("계약기간")]),
        _c("dd", [_vm._v("제한없음")]),
        _c("dt", [_vm._v("가입통화")]),
        _c("dd", [_vm._v("USD, KHR")]),
        _c("dt", [_vm._v("가입금액")]),
        _c("dd", [_vm._v("신규가입 시 최저 USD 100.00 이상")]),
        _c("dt", [_vm._v("금리 및 이율")]),
        _c("dd", [
          _vm._v(" USD : 약정이율 연 0.50%"),
          _c("br"),
          _vm._v(" KHR : 약정이율 연 0.70% ")
        ]),
        _c("dt", [_vm._v("수수료")]),
        _c("dd", [_vm._v("해당무")]),
        _c("dt", [_vm._v("가입방법")]),
        _c("dd", [_vm._v("영업점가입")]),
        _c("dt", [_vm._v("가입시 필요서류")]),
        _c("dd", [
          _vm._v(
            " 대표자 내점시 : 사업허가증, 법인등기부등본, 사업자등록증, 정관, 주총결의서, 여권 사본 등"
          ),
          _c("br"),
          _vm._v(
            " 대리인 내점시 : 사업허가증, 법인등기부등본, 사업자등록증, 정관, 주총결의서, 여권 사본, 위임장 및 대리인 실명확인증"
          ),
          _c("br"),
          _vm._v(
            " ·위임장에는 신청직원의 인적사항 및 위임내용이 기재되어야 하며, 법인인감날인이 필요합니다. "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h2", [_vm._v("Corporate Current Account")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _c("p", [
        _vm._v(
          " Savings that can deposit and withdraw money freely for an archival purpose of a temporary surplus funds "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "tit" }, [
        _c("span", { staticClass: "exchange-unit" }, [_vm._v("USD")])
      ]),
      _c("div", { staticClass: "percent" }, [_vm._v(" 0.50% annually ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "tit" }, [
        _c("span", { staticClass: "exchange-unit" }, [_vm._v("KHR")])
      ]),
      _c("div", { staticClass: "percent" }, [_vm._v(" 0.70% annually ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { staticClass: "contents" }, [
      _c("dl", { staticClass: "dlist dlist-item--type5" }, [
        _c("dt", [_vm._v("Types")]),
        _c("dd", [_vm._v("Current Account")]),
        _c("dt", [_vm._v("About the products")]),
        _c("dd", [
          _vm._v(
            "Savings that can deposit and withdraw money freely for an archival purpose of a temporary surplus funds"
          )
        ]),
        _c("dt", [_vm._v("Eligibilty")]),
        _c("dd", [_vm._v("Enterprise")]),
        _c("dt", [_vm._v("Contract Terms")]),
        _c("dd", [_vm._v("No restrictions")]),
        _c("dt", [_vm._v("Available currency")]),
        _c("dd", [_vm._v("USD, KHR")]),
        _c("dt", [_vm._v("Deposit amount")]),
        _c("dd", [
          _vm._v(
            "To open a new account, a minimum USD 100.00 deposit amount is required."
          )
        ]),
        _c("dt", [_vm._v("Rates")]),
        _c("dd", [
          _vm._v(" USD : Agreed interest rate of 0.50% annually"),
          _c("br"),
          _vm._v(" KHR : Agreed interest rate of 0.70% annually ")
        ]),
        _c("dt", [_vm._v("Fees")]),
        _c("dd", [_vm._v("N/A")]),
        _c("dt", [_vm._v("How to apply")]),
        _c("dd", [_vm._v("Apply at the branch")]),
        _c("dt", [_vm._v("Required documents for application")]),
        _c("dd", [
          _vm._v(
            " When a representative visits : business license, certified copy of corporate registration, business registration card, articles of incorporation, written resolution of general stockholders meeting, a copy of passport, etc."
          ),
          _c("br"),
          _vm._v(
            " When a surrogate visits : business license, certified copy of corporate registration, business registration certificate, articles of incorporation, written resolution of general stockholders meeting, a copy of passport, a letter of attorney and surrogate's ID"
          ),
          _c("br"),
          _vm._v(
            " ·A letter of attorney is required to have a surrogate's personal information and contents of dlegation, and corporate seal "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h2", [_vm._v("គណនីសន្សំសំរាប់ក្រុមហ៊ុន")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _c("p", [
        _vm._v(
          " បញ្ចូលទឹកប្រាក់ធម្មតាដែលអាចរក្សាប្រាក់ទុកក្នុងធនាគារហើយអាច បញ្ចុលប្រាក់និងដកប្រាក់បាន។ "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "tit" }, [
        _c("span", { staticClass: "exchange-unit" }, [_vm._v("USD")]),
        _c("span", { staticClass: "text" }, [
          _vm._v("ក្នុងកិច្ចសន្យា ការប្រាក់ក្នុងមួយឆ្នាំ")
        ])
      ]),
      _c("div", { staticClass: "percent" }, [_vm._v(" 0.50% ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "tit" }, [
        _c("span", { staticClass: "exchange-unit" }, [_vm._v("KHR")]),
        _c("span", { staticClass: "text" }, [
          _vm._v("ក្នុងកិច្ចសន្យា ការប្រាក់ក្នុងមួយឆ្នាំ")
        ])
      ]),
      _c("div", { staticClass: "percent" }, [_vm._v(" 0.70% ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { staticClass: "contents" }, [
      _c("dl", { staticClass: "dlist dlist-item--type5" }, [
        _c("dt", [_vm._v("ប្រភេទផលិតផល")]),
        _c("dd", [_vm._v("បា្រក់បញ្ញើធម្មតា")]),
        _c("dt", [_vm._v("មាតិកាផលិតផល")]),
        _c("dd", [
          _vm._v(
            "បញ្ចូលទឹកប្រាក់ធម្មតាដែលអាចរក្សាប្រាក់ទុកក្នុងធនាគារហើយអាច បញ្ចុលប្រាក់និងដកប្រាក់បាន។"
          )
        ]),
        _c("dt", [_vm._v("អតិថិជនគោលដៅ")]),
        _c("dd", [_vm._v("សហគ្រាស")]),
        _c("dt", [_vm._v("រយៈពេលកិច្ចសន្យា")]),
        _c("dd", [_vm._v("មិនមានកំនត់")]),
        _c("dt", [_vm._v("ប្រភេទរូបិយប័ណ្ណដែលស្នើសុំ")]),
        _c("dd", [_vm._v("USD, KHR")]),
        _c("dt", [_vm._v("ចំនួនទឹកប្រាក់ដែលស្នើសុំ")]),
        _c("dd", [_vm._v("ចំនួនទឹកប្រាក់ដំបូងតិចបំផុត USD100.00")]),
        _c("dt", [_vm._v("អត្រាការប្រាក់")]),
        _c("dd", [
          _vm._v(" USD : ក្នុងកិច្ចសន្យា ការប្រាក់ក្នុងមួយឆ្នាំ0.50%"),
          _c("br"),
          _vm._v(" KHR : ក្នុងកិច្ចសន្យា ការប្រាក់ក្នុងមួយឆ្នាំ0.70% ")
        ]),
        _c("dt", [_vm._v("កំរៃសេវា")]),
        _c("dd", [_vm._v("គ្មាន")]),
        _c("dt", [_vm._v("របៀបចុះឈ្មោះ")]),
        _c("dd", [_vm._v("ចុះឈ្មោះនៅសាខា")]),
        _c("dt", [_vm._v("តំរូវការឯកសារចុះឈ្មោះ")]),
        _c("dd", [
          _vm._v(" - លិខិតអនុញ្ញាតបើកអាជីវកម្ម"),
          _c("br"),
          _vm._v(" - អាជ្ញាប័ណ្ណប្រកបអាជីវកម្ម និង ប័ណ្ណប៉ាតង"),
          _c("br"),
          _vm._v(" ់ - សេចក្ដីសម្រេចរបស់ក្រុមប្រឹក្សាភិបាល"),
          _c("br"),
          _vm._v(" - ក្ខន្តិកៈក្រុមហ៊ុន"),
          _c("br"),
          _vm._v(
            " - អត្ដសញ្ញាណប័ណ្ណ រឺ លិខិតឆ្លងដែនច្បាប់ដើមរបស់អភិបាល និង អ្នកទទួលសិទ្ឋិប្រសិនមាន។ "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }